<template>
  <div id="top" :style="{'position':positionType,'top':topValue}">
    <div class="container flex flex-y flex-center">
      <!-- logo -->
      <!-- <img src="@/assets/images/public/logo.png" class="logo"> -->
      <div class="logo flex">
        <img src="@/assets/images/public/logo-type2-v2.0.png">
        <!-- <div class="content">
          <p>图小助</p>
          <p>tuxiaozhu.com</p>
        </div>-->
      </div>
      <!-- nav -->
      <el-menu
        class="el-menu-demo"
        :default-active="$route.path"
        mode="horizontal"
        text-color="#212240"
        active-text-color="#5456FF"
        router
      >
        <el-menu-item index="/">首页</el-menu-item>
        <!-- <el-menu-item index="/recruitPartners">招募合伙人</el-menu-item> -->
        <el-submenu index="/recruitPartners">
          <template slot="title">招募合伙人</template>
          <el-menu-item index="/performance">效果图设计师</el-menu-item>
          <el-menu-item index="/construction">施工图深化</el-menu-item>
          <el-menu-item index="/sketchUp">草图大师</el-menu-item>
          <!-- <el-menu-item index="/reTouch">改图师</el-menu-item> --> <!-- 暂时隐藏 -->
         </el-submenu>
        <el-menu-item index="/cost">关于收费</el-menu-item>
        <el-menu-item index="/modify">关于改图</el-menu-item>
        <el-menu-item index="/about">关于图小助</el-menu-item>
        <el-menu-item @click="handleClick()">联系我们</el-menu-item>
      </el-menu>
      <!-- login -->
      <button class="login" @click="jump()">设计助理登录</button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  props: ["positionType", "topValue"],
  data() {
    return {
      child: [
        { title: "效果图设计师", index: "/performance" },
        { title: "施工图深化", index: "/construction" },
        { title: "草图大师", index: "/sketchUp" },
        /* { title: "改图师", index: "/retouch" } */
      ],
      scroll: false,
      baseUrl: "http://admin.tuxiaozhu.com",
    };
  },
  methods: {
    handleClick() {
      this.scroll = true;
      this.setScroll(this.scroll);
    },
    ...mapMutations(["setScroll"]),
    jump() {
      window.location.href = this.baseUrl + "?" + "status=" + 1;
    }
  }
};
</script>

<style lang="scss" scoped>
#top {
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #dedede;
  height: 66px;
  min-width: 1300px;
  z-index: 9999;
  // opacity: 0.9;
  display: flex;
  align-items: center;
  .container {
    // padding: 15px 0;
    //logo
    margin: 0 auto;
    .logo {
      margin-right: 107px;
      img {
        width: 108px;
        height: 39px;
      }
    }
    //导航
    .nav {
      li {
        margin: 0 15px;
        cursor: pointer;
        transition: all 0.3s;
      }
      li:hover {
        color: #5456ff;
        transition: all 0.3s;
      }
    }
    //login
    .login {
      padding: 8px 12px;
      color: #625cff;
      border: 1px solid #615bff;
      border-radius: 20px;
      transition: all 0.3s;
      cursor: pointer;
      margin-left: 107px;
    }
    .login:hover {
      color: #fff;
      background-color: #615bff;
      opacity: 0.9;
      transition: all 0.5s;
    }
  }
}
.el-dropdown-link {
  //color: #333;
  font-size: 15px;
  cursor: pointer;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0;
}
.el-menu-item {
  margin-right: 50px;
  &:last-child {
    margin-right: 0;
  }
}
.el-submenu {
  margin-right: 38px;
}
li {
  font-weight: 500;
}
.el-menu-item.is-active {
  border-bottom: 0;
}
</style>

<style lang="scss">
#top {
  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border: 0;
  }
}
</style>

